import React from 'react'
import PropTypes from 'prop-types'
import {Blocks, isEditing} from '@builder.io/sdk-react'
import {CustomAccordion} from '@/components/accordion'
import {defaultItem} from './defaultConfig'

export const BuilderAccordion = ({
    items,
    builderBlock,
    arrowDirection,
    highlightExpandedItem,
    oneAtATime,
    attributes,
    'data-testid': dataTestId
}) => {
    const {className, ...restAttributes} = attributes

    return (
        <CustomAccordion
            items={items}
            oneAtATime={oneAtATime}
            arrowDirection={arrowDirection}
            highlightExpandedItem={highlightExpandedItem}
            className={className}
            isEditing={isEditing}
            {...restAttributes}
            data-testid={dataTestId || 'accordion-Accordion'}
            renderItem={({item, index}) => (
                <Blocks
                    path={`component.options.items.${index}.content`}
                    blocks={[item]}
                    parent={builderBlock?.id}
                    data-testid="accordion-Blocks"
                />
            )}
        />
    )
}

BuilderAccordion.propTypes = {
    attributes: PropTypes.object,
    items: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    arrowDirection: PropTypes.string,
    highlightExpandedItem: PropTypes.bool,
    oneAtATime: PropTypes.bool,
    builderBlock: PropTypes.object,
    'data-testid': PropTypes.string
}

export const AccordionDefinition = {
    component: BuilderAccordion,
    name: 'Builder:Accordion',
    override: true,
    category: 'Accordion Components',
    canHaveChildren: true,
    noWrap: true,
    childRequirements: {
        message: "Children of 'Accordion' must be 'AccordionItem'",
        query: {
            'component.name': {$in: ['AccordionItem']}
        }
    },
    shouldReceiveBuilderProps: {
        builderBlock: true
    },
    defaultStyles: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch'
    },
    inputs: [
        {
            name: 'items',
            type: 'uiBlocks',
            defaultValue: [
                {
                    content: [defaultItem]
                }
            ]
        },
        {
            name: 'oneAtATime',
            helperText:
                'Only allow opening one at a time (collapse all others when new item opened)',
            type: 'boolean',
            defaultValue: false
        },
        {
            name: 'arrowDirection',
            type: 'string',
            enum: ['right', 'down'],
            defaultValue: 'right',
            helperText: 'Display arrow direction to bottom (default is to right)',
            friendlyName: 'Arrow Direction'
        },
        {
            name: 'highlightExpandedItem',
            friendlyName: 'Highlight accordion item when expanded with background color',
            type: 'boolean',
            defaultValue: false,
            helperText: 'Background color will be applied only when item is opened'
        }
    ]
}
